import { Outlet, createFileRoute, redirect } from '@tanstack/react-router'

export const Route = createFileRoute('/manage-booking')({
  beforeLoad: ({ context }) => {
    if (context.authContext.isAuthenticated) {
      return redirect({
        to: '/home',
      })
    }
  },
  component: RouteComponent,
})

function RouteComponent() {
  return <Outlet />
}
